"use client";

import type { AddonDietAddonsRead } from "@repo/api/catalog/api/schemas/addon-diet-addons-read";
import type { SelectedAddon } from "@/features/addons/lib/aggregate-selected-addons";
import { SummaryAddonItem } from "./summary-addon-item";

// Body of every "Dodatki" expansion (configuration aside, cart list, checkout
// sidebar, order details): the addon rows.
//
// The deposit is spelled out on each row and never added to the addons amount,
// the same way the cart contract keeps `deposit` outside `final` and out of the
// cart total — folding it in would show a number nobody is charged.
export const SummaryAddonsList = ({
  items,
  cateringName,
  hideSeller,
  onEdit,
  onRemove,
  renderRemoved,
  children,
}: {
  items: SelectedAddon[];
  // Seller shown on rows whose addon names none (MPL-3832).
  cateringName?: string;
  // Rows inside a per-seller group: the header already names the seller.
  hideSeller?: boolean;
  // Both handlers together turn the rows into editable ones (cart list); with
  // neither the list is read-only.
  onEdit?: (addon: AddonDietAddonsRead) => void;
  onRemove?: (addonId: string) => void;
  // Takes over the row of an addon waiting out its undo window: the
  // selection is still there, only its row is replaced.
  renderRemoved?: (addonId: string) => React.ReactNode | null;
  children?: React.ReactNode;
}) => {
  return (
    <>
      <ul className="flex flex-col gap-3">
        {items.map((item) => (
          <li key={item.addon.id}>
            {renderRemoved?.(item.addon.id) ?? (
              <SummaryAddonItem
                cateringName={cateringName}
                hideSeller={hideSeller}
                item={item}
                onEdit={onEdit && (() => onEdit(item.addon))}
                onRemove={onRemove && (() => onRemove(item.addon.id))}
              />
            )}
          </li>
        ))}
      </ul>

      {children}
    </>
  );
};
